import { render } from "./DeepZoomSample.vue?vue&type=template&id=3818efb8"
import script from "./DeepZoomSample.vue?vue&type=script&lang=js"
export * from "./DeepZoomSample.vue?vue&type=script&lang=js"

import "./DeepZoomSample.vue?vue&type=style&index=0&id=3818efb8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__